import React from 'react';
import classnames from 'classnames';
import propTypes from 'prop-types';
import TextField from '../text-field/text-field';
import SelectField from '../select-field/select-field';
import mergeI18n from '../../lib/util/merge-i18n';
import formatPhone from '../../lib/formatters/phone-formatter';
import i18n from './i18n';

const { bool, func, string } = propTypes;

function PhoneField (props) {
	const __ = mergeI18n(props.language, i18n);

	const phoneClassNames = classnames({
		'row': true,
		'phone-field': true,
		'form-error': props.formError
	});

	function cleanPhone (fn) {
		return function (event) {
			event.target.value = event.target.value.replace(/\D/g, '');
			return fn(event);
		};
	}

	return (
		<div className='form-group'>
			{props.label && <span className='lss-form-label' htmlFor={props.name}>{props.label}<br /></span>}
			<div className={phoneClassNames}>
				<div className='col-xs-7 col-sm-8 phone'>
					<TextField
						type='tel'
						placeholder={__.inputs.phone.placeholder}
						id={props.name}
						name={props.phoneName}
						value={formatPhone(props.phoneValue)}
						onChange={cleanPhone(props.onChange)}
						onBlur={cleanPhone(props.onBlur)}
						formError={props.formError}
					/>
				</div>
				<div className='col-xs-5 col-sm-4 phone-type'>
					<SelectField
						name={props.phoneTypeName}
						value={props.phoneTypeValue}
						onChange={props.onChange}
						ios={props.ios}
						onBlur={props.onBlur}
						options={__.phoneTypes}
						emptyDefaultValue={false}
					/>
				</div>
			</div>
		</div>
	);
}

PhoneField.propTypes = {
	language: string.isRequired,
	label: string,
	ios: bool,
	phoneName: string.isRequired,
	phoneValue: string.isRequired,
	phoneTypeName: string.isRequired,
	phoneTypeValue: string.isRequired,
	placeholder: string,
	formError: string,
	onChange: func.isRequired,
	onBlur: func.isRequired
};

export default PhoneField;
